import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import BannerLanding from '../components/BannerLanding'
//import { Grid, Row, Col } from 'react-flexbox-grid';

const pageTitle = "Pack e-commerce";
const pageContent = ["Contenu de la prestation pour la création d'un site e-commerce", "avec Prestashop ou Wordpress Woocommerce"];

const Generic = (props) => (
	<div style={props.transition && props.transition.style}>
		<Helmet>
			<title>Web2alpes - {pageTitle}</title>
			<meta name="description" content="Actions réalisées pour la création d'un site e-commerce Prestashop ou Wordpress Woocommerce" />
			<meta name="language" content="fr-FR" />
            <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
            <meta http-equiv="content-language" content="fr-FR" />
		</Helmet>
		<BannerLanding title={pageTitle} content={pageContent} particles="cms" color="style-logo-lg" />
		<div id="main" className="alt">
			<section id="support" className="tiles">
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Installation</h2>
						</header>
						<ul className="snow">
							<li>Mise en place d’une boutique utilisant les CMS PrestaShop (1.7) ou Wordpress Woocommerce (4.9),</li>
							<li>Recherche de l'hébergeur et du registrar le plus adapté aux besoins,</li>
							<li>Inscription, activation de l’hébergement et du nom de domaine, installation site pilote vers version production,</li>
							<li>Optimisation du système de cache et minification du contenu de la boutique afin d'améliorer grandement les performances,</li>
							<li>Intégration d’un certificat HTTPS pour sécuriser le site Internet,</li>
							<li>Configuration et sécurisation du backoffice pour la gestion de la boutique PrestaShop / Wordpress (catalogue produits, commandes, publications,…),</li>
							<li>Mise en place de la sauvegarde de la e-boutique,</li>
							<li>Possibilité d'installation et de configuration de la station de travail et imprimante pour la gestion du site e-commerce.</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Accompagnement</h2>
						</header>
						<ul className="snow">
							<li>Mise en place des pages : accueil, mentions légales, conditions générales de vente, modes de paiements, modes de livraisons, conditions de retours, formulaire de contact et à propos,</li>
							<li>Création des différents comptes utilisateurs pour l'exploitation de la boutique,</li>
							<li>Création et configuration des comptes prestashop, woocommerce, paypal, google, envoimoinscher,</li>
							<li>Rédaction documentation (informations complètes site, comptes, hébergement, processus gestion de commandes),</li>
							<li>Formation à distance ou sur site à la gestion des commandes, ajout et modification de produits.</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Referencement</h2>
						</header>
						<ul className="snow">
							<li>Structure en silos thématiques pour améliorer le maillage interne et donc la pertinence pour le référencement naturel (Google donne beaucoup d’intérêt à cette structure),</li>
							<li>Statistiques en temps réel de la boutique (visiteurs en ligne, paniers en cours, fréquentation, produits, commandes, sites affluents, mots clefs,…),</li>
							<li>Intégration d’un module SEO pour l’optimisation du référencement naturel pour Prestashop ou Wordpress,</li>
							<li>Mise en place de Google Analytics pour suivre votre référencement,</li>
							<li>Intégration du fichier sitemap XML pour faciliter l’indexation des moteurs de recherches,</li>
							<li>Intégration du plan du site pour limiter les niveaux de profondeur des pages,</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Configuration</h2>
						</header>
						<ul className="snow">
							<li>Une seule langue configurée pour le site e-commerce,</li>
							<li>Personnalisation du thème en fonction de votre identité visuelle et de vos attentes,</li>
							<li>Intégration de votre logo à la e-boutique,</li>
							<li>Intégration de vos différents visuels en page d’accueil,</li>
							<li>Intégration de fonctionnalités de partages sur les fiches produits : Facebook, Google+...,</li>
							<li>Intégration d’un formulaire de retour et de la fonctionnalité d’envoi des conditions générales de vente en accord avec la loi Hamon,</li>
							<li>Intégration d’un bandeau d’information sur l’utilisation des cookies,</li>
							<li>Importations des premiers produit jusqu'à l’ensemble des produits,</li>
							<li>Configuration de systèmes de paiements par défaut (chèque et virement bancaire, Paypal),</li>
							<li>Intégration du module EnvoiMoinsCher pour prestashop (pour la France uniquement, qui comprend les transporteurs : Colissimo, Chronopost, Colis Privé, Mondial Relay, Relais Colis, DHL, Fedex, TNT, UPS...) et de l'extension Woocommerce pour Wordpress.</li>
						</ul>
					</div>
				</article>
			</section>
		</div>
	</div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/pack-e-commerce.js